/* eslint-disable no-new, spaced-comment, import/first */

import 'babel-polyfill'

import AllPublicMethods from 'src/AllPublicMethods'
const api = new AllPublicMethods()

/*//
import QueueParallel from 'src/QueueParallel'
new QueueParallel(api)
/*/
import QueueSerial from 'src/QueueSerial'
new QueueSerial(api)
//*/



// WEBPACK FOOTER //
// ./src/entry-browser.js